export const environment = {
	acmIdmLogoutUrl: 'https://authenticatie-ti.vlaanderen.be/op/v1/logout',
	rrnAppUrl: 'https://test-app.iedereenverdientvakantie.be/rrn',
};
